/** Smart prompt 最大字符数 */
export const COVER_MAX_DESCRIPTION_LENGTH = 500

/** Custom lyrics 最大字符数 */
export const COVER_MAX_LYRICS_LENGTH = 5000

/** Style text 最大字符数 */
export const COVER_MAX_STYLE_LENGTH = 300
